export default () => ({
  errors: [],
  loading: true,
  endpoint: null,
  sortField: 'last_seen',
  statusFilter: 'unresolved',
  searchQuery: null,
  indexPath: '',
  recentSearches: [],
  pagination: {},
  cursor: null,
});
